export const coinReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_SINGLE_COIN":
      return { ...action.payload };
    default:
      return state;
  }
};
